import type { PolarYesNoUndefined } from "@stryker/core/types/section";
import TickIcon from "@/assets/icons/tick.svg?react";
import { Button } from "@/components/ui/button";
import { Typography } from "@/components/ui/typography";

type PolarQuestionProps = {
  shouldRender: boolean;
  selection: PolarYesNoUndefined;
  onYesClick: (e: React.MouseEvent) => void;
  onNoClick: (e: React.MouseEvent) => void;
  question: string;
};
export default function PolarQuestion({
  question,
  shouldRender,
  selection,
  onYesClick,
  onNoClick,
}: PolarQuestionProps) {
  if (!shouldRender) return null;

  return (
    <div className="mt-4 flex">
      <Typography weight="semibold" variant="text-xl">
        {question}
      </Typography>
      <Button className="ml-auto mr-2 flex gap-2" variant="outline" onClick={(e) => onNoClick(e)}>
        {selection === "no" && <TickIcon className="stroke-gray-700" />}
        No
      </Button>
      <Button type="button" onClick={(e) => onYesClick(e)} className="flex gap-2">
        {selection === "yes" && <TickIcon className="stroke-gray-700" />}
        Yes
      </Button>
    </div>
  );
}
